import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { PUBLISHING_KD } from 'src/constants/services';
import { privacyPolicyQuery } from 'src/hooks/Policy';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

const HeadC = dynamic(() => import('src/components/Head'));
const PrivacyContainer = dynamic(() => import('src/containers/Privacy'));

const Privacy = () => {
	return (
		<>
			<HeadC
				title="Kebijakan Privasi"
				description={
					'Kebijakan Privasi ini adalah komitmen nyata dari KlikDokter untuk menghargai ' +
					'dan melindungi setiap data dan/atau informasi pribadi pengguna situs.'
				}
			/>

			<PrivacyContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	await queryClient.prefetchQuery({
		queryKey: [privacyPolicyQuery],
		queryFn: () =>
			fetchApiV3Publishing({
				url: `/public/kd/${PUBLISHING_KD.model.privacyPolicy}`,
			}),
	});

	return {
		props: {
			hideConsent: true,
			dehydratedState: dehydrate(queryClient),
			pageHeaderContent: {
				title: 'Kebijakan Privasi',
				hideHeadingTitle: true,
				breadcrumbs: [{ label: 'Kebijakan Privasi' }],
				isWhiteSpaceOnMobile: true,
			},
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default Privacy;
